import moment from 'moment';
import type {ExchangeRate, RateStatus} from './types';

export const hasRateStarted = (startDate: string | null, today: moment.Moment): boolean =>
	startDate === null || !moment(startDate).isAfter(today, 'day');

export const hasRateEnded = (endDate: string | null, today: moment.Moment): boolean =>
	endDate !== null && moment(endDate).isBefore(today, 'day');

export const getRateStatus = (rate: ExchangeRate, today: moment.Moment): RateStatus => {
	if (hasRateEnded(rate.endDate, today)) return 'past';
	return 'current';
};

export const compareRateAsc = (a: number | null, b: number | null): number => (a ?? 0) - (b ?? 0);
